import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();

  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#002FA7]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}
